import { ChevronDown, Sparkles } from 'lucide-react';

interface FAQProps {
  section: any;
}

export default function FAQ({ section }: FAQProps) {
  const items: any[] = section.content?.items ?? [];
  const headingId = `faq-heading-${section.id}`;

  if (items.length === 0) return null;

  return (
    <section aria-labelledby={headingId} className="bg-cream">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          {section.title && (
            <h2
              id={headingId}
              className="font-display text-3xl font-bold text-sage-900 sm:text-4xl"
            >
              {section.title}
            </h2>
          )}
          {section.subtitle && (
            <p className="mt-2 text-sage-600 max-w-xl mx-auto">
              {section.subtitle}
            </p>
          )}
          <div className="mt-4 flex items-center justify-center gap-3" aria-hidden="true">
            <div className="h-px w-12 bg-sage-300" />
            <Sparkles className="h-4 w-4 text-sage-400" />
            <div className="h-px w-12 bg-sage-300" />
          </div>
        </div>

        {/* Accordion */}
        <div className="divide-y divide-sage-200 border-y border-sage-200">
          {items.map((item: any, i: number) => (
            <details key={i} className="group">
              <summary className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-600 rounded transition-colors [&::-webkit-details-marker]:hidden">
                <span className="font-display text-base font-semibold text-sage-900 group-hover:text-sage-700 transition-colors">
                  {item.question}
                </span>
                <ChevronDown
                  className="h-5 w-5 shrink-0 text-sage-400 transition-transform duration-200 group-open:rotate-180"
                  aria-hidden="true"
                />
              </summary>
              <div className="pb-5 pr-12">
                <p className="text-sm leading-relaxed text-sage-600">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
